import React, { useEffect, useState } from 'react'
import { pick } from 'dot-object'
import { useDataProvider } from 'src/mtska-frontend-data-provider'
import { Autocomplete, Box, CircularProgress } from '@mui/joy'
import { Cell } from '.'

let optionsCache = []

export const CellRelationship = (props) => {

    const {
        action,
        configFilters: items,
        field,
        fieldKey,
        optionLabel,
        optionsDataProviderName,
        processRowUpdate,
        row = {},
        type,
        value = {}
    } = props

    const [currentValue, setCurrentValue] = useState(value || {})
    const [editMode, setEditMode] = useState(false)
    const [options, setOptions] = useState([])

    const { loadAll } = useDataProvider(optionsDataProviderName)

    useEffect(() => {
        editMode && onFocus()
    }, [editMode])

    useEffect(() => {
        optionsCache = []
    }, [optionsDataProviderName])

    const onChange = (_event, value) => {
        setCurrentValue(value)
        const updatedRow = { ...row, [fieldKey || field]: value }
        processRowUpdate(updatedRow, row, action)
        setEditMode(false)
    }

    const onFocus = () => {
        if (optionsCache.length > 0) {
            setOptions(optionsCache)
        } else if (options.length === 0) {
            setOptions(undefined)
            loadAll({ items }).then((data = {}) => {
                const { items = {} } = data
                const { data: options = [] } = items
                const newOptions = [{}, ...options]
                setOptions(newOptions)
                optionsCache = newOptions
            })
        }
    }

    const hasValue = typeof currentValue === 'object' && Object.keys(currentValue || {}).length > 0

    return (
        <Box className={"list-element-cell cell-contract cell-contract-" + type}>
            {editMode
                ? (
                    <Autocomplete
                        autoFocus={editMode}
                        endDecorator={!options && <CircularProgress size="sm" />}
                        // getOptionKey={(option) => pick(optionKey, option)}
                        getOptionLabel={(option) => option && pick(optionLabel, option) ? pick(optionLabel, option) : 'Nessuno'}
                        loading={!options}
                        onChange={onChange}
                        onClose={() => setEditMode(false)}
                        onKeyDown={(e) => e.stopPropagation()}
                        open={editMode}
                        options={options || []}
                        sx={{ width: '100%' }}
                        value={hasValue ? currentValue : null}
                        variant='plain'
                    />
                )
                : (
                    <div onClick={() => setEditMode(true)} style={{ height: '100%', width: '100%' }}>
                        <Cell {...props} />
                    </div>
                )
            }
        </Box>
    )
}
